import React from 'react'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { Globe } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { InputWithIcon } from 'components/AdminConsole/commonUI/InputWithIcon'
import useLocaleText from 'components/useLocaleText'
import { getLinkPopUrl } from 'components/PopOverview/model/linkPop'
import { linkPopLiterals } from 'components/PopOverview/model/literals'
import { getNestedError, MAX_BODY_LENGTH } from '../utils'
import { LinkUrlPreview } from './LinkUrlPreview'

export function LinkUrlField() {
  const { register, errors, watch } = useFormContext()
  const label = useLocaleText(linkPopLiterals.url)
  const placeholder = useLocaleText(linkPopLiterals.urlPlaceholder)
  const required = useLocaleText(linkPopLiterals.urlRequired)
  const invalid = useLocaleText(linkPopLiterals.urlInvalid)
  const tooLong = useLocaleText(linkPopLiterals.urlTooLong)
  const value = watch('data.pop_body') || ''

  const error = getNestedError(errors, 'data.pop_body')
  const safeUrl = value.length <= MAX_BODY_LENGTH ? getLinkPopUrl(value) : null

  return (
    <StyledFormControl isInvalid={!!error}>
      <StyledFormLabel required htmlFor="pop-link-url">
        <Text>{label}</Text>
      </StyledFormLabel>
      <InputWithIcon
        id="pop-link-url"
        name="data.pop_body"
        type="url"
        inputMode="url"
        dir="ltr"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        icon={<Globe size={18} strokeWidth={2} aria-hidden="true" />}
        elementProps={{ pointerEvents: 'none' }}
        placeholder={placeholder}
        aria-describedby="pop-link-url-counter pop-link-url-error"
        ref={register({
          required,
          maxLength: { value: MAX_BODY_LENGTH, message: tooLong },
          validate: (value: string) => (!value?.trim() ? required : !!getLinkPopUrl(value) || invalid),
        })}
      />
      <Text id="pop-link-url-counter" fontSize="12px" color="gray.500" textAlign="end" mt={1} dir="ltr">
        {value.length}/{MAX_BODY_LENGTH}
      </Text>
      <FormErrorMessage id="pop-link-url-error">{error?.message}</FormErrorMessage>
      {safeUrl && <LinkUrlPreview key={safeUrl} url={safeUrl} />}
    </StyledFormControl>
  )
}
